module.exports = __webpack_public_path__ + "static/media/slideFourTablet.b882dc83.png";